
<div class="store-selection-dialog-wrapper">
  <h2 mat-dialog-title>Store Selection</h2>
  <!-- <mat-tab-group [(selectedIndex)]="tabIndex" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="All"></mat-tab>
    <mat-tab label="Sushi"></mat-tab>
    <mat-tab label="Bento"></mat-tab>
  </mat-tab-group> -->
  <div class="search-row">
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Search.." [(ngModel)]="searchText">
    </mat-form-field>
  </div>
  <div class="select-row">
    <mat-checkbox
      [checked]="isAllSelected()"
      [indeterminate]="isIndeterminate()"
      (change)="toggleAll()"
    >
      Select All / None
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="selectedOnly">Selected Only</mat-checkbox>
  </div>
  <div class="store-list">
    <div *ngFor="let store of filteredStores" class="store-item" [class.selected]="selectedStoreIds.has(store.id)" (click)="!isStoreDisabled(store) && toggleStore(store.id)">
      <mat-checkbox [checked]="selectedStoreIds.has(store.id)" (click)="$event.stopPropagation(); toggleStore(store.id)"></mat-checkbox>
      <span>{{ store.name }}</span>
      <mat-icon *ngIf="selectedStoreIds.has(store.id)">check</mat-icon>
    </div>
  </div>
  <div class="bottom-row">
    <mat-checkbox [(ngModel)]="includeSameStoreLY">Include only same store LY</mat-checkbox>
  </div>
  <div class="dialog-actions">
    <button mat-raised-button color="primary" (click)="applyFilter()">Apply</button>
    <button mat-button (click)="cancel()">Cancel</button>
  </div>
</div>
